import { Account } from './account.model';
import { User } from './user.model';

export const RESOLVE_KEY = 'accountData'; // key is the same as the RESOLVE in account-data.resolve.ts

export interface IAccountDataResolveData {
  account: Account;
  user: User;
  isOwner: boolean;
}
